/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Col, Label, Alert,
} from 'reactstrap';
import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../helpers/api_helper';
import * as urls from '../../helpers/url_helper';

function UserForm(props) {
  const { entity, t, onSuccess } = props;

  // eslint-disable-next-line no-unused-vars
  const [roles, setRoles] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(true);
  const [loading, setLoading] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [user, setUser] = useState(entity);

  useEffect(() => {
    const fetchRoles = async () => {
      const data = await get(urls.GET_ROLES);

      setRoles(data);
      setLoadingRoles(false);
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const data = await get(`/api/user/view/${entity.id}`);

      setUser(data);
    };

    if (entity.id) {
      fetchData();
    }
  }, [entity]);

  const saveUser = async (values, rst) => {
    try {
      setLoading(true);
      await post('/api/user/save', values);
      rst();
      setErrorMessage(null);
      setSuccessFlag(true);
      onSuccess();
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
      setSuccessFlag(false);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Invalid email address format')
      .required('Email is required'),
    real_name: Yup.string().required('Real name is required'),
    display_name: Yup.string().required('Display name is required'),
    roles: Yup.array().min(1, 'At least 1 role must be selected'),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      <Alert color="success" className="mt-3" isOpen={(successFlag)}>
        {props.t('User created successfully')}
      </Alert>
      { em }
      <Formik
        enableReinitialize
        initialValues={{ ...user, roles: user.role_ids ? user.role_ids.split(',').map((x) => parseInt(x, 10)) : [] }}
        validationSchema={ValidationSchema}
        onSubmit={(values, actions) => {
          saveUser(values, actions.resetForm);
        }}
      >
        {({
          touched, setFieldValue, errors, values,
        }) => (
          <Form className="mt-3" autoComplete="off" id="UserForm">
            <div className="row mt-4 mb-4">
              <Label
                for="makedname"
                className="col-sm-3 col-form-label"
              >
                {t('Display Name')}
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.display_name && touched.display_name ? 'is-invalid' : '')}`}
                  id="makedname"
                  name="display_name"
                />
                <ErrorMessage
                  name="display_name"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="makerealname"
                className="col-sm-3 col-form-label"
              >
                {t('Real Name')}
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.real_name && touched.real_name ? 'is-invalid' : '')}`}
                  id="makerealname"
                  name="real_name"
                />
                <ErrorMessage
                  name="real_name"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mb-4">
              <Label
                for="makeemail"
                className="col-sm-3 col-form-label"
              >
                {t('Email Address')}
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.email && touched.email ? 'is-invalid' : '')}`}
                  id="makeemail"
                  name="email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mb-4">
              <Label
                for="roles"
                className="col-sm-3 col-form-label"
              >
                {loadingRoles === true && <div>Loading </div>}
                {t('Roles')}
              </Label>

              <Col sm={9}>
                <FieldArray
                  name="roles"
                  render={(arrayHelpers) => (
                    <>
                      {roles.map((role, index) => (
                        <div key={role.id} className="form-check form-check-primary mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`roleCheck${index}`}
                            name="roles"
                            value={role.id}
                            checked={values.roles?.includes(role.id) || false}
                            onChange={(event) => {
                              if (event.target.checked) {
                                arrayHelpers.push(role.id);
                              } else {
                                const idx = values.roles.indexOf(role.id);
                                arrayHelpers.remove(idx);
                              }
                            }}
                          />
                          <label className="form-check-label" htmlFor={`roleCheck${index}`}>
                            {role.name}
                          </label>
                        </div>
                      ))}
                      {errors.roles && touched.roles && (
                        <>
                          <div className="is-invalid" />
                          <ErrorMessage
                            name="roles"
                            component="div"
                            className="invalid-feedback"
                          />
                        </>
                      )}
                    </>
                  )}
                />
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

UserForm.defaultProps = {
  t: (x) => (x),
  entity: {
    name: '', email: '', roles: [], role_ids: '',
  },
  onSuccess: () => {},
};

UserForm.propTypes = {
  t: PropTypes.func,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(UserForm));
